import { useDispatch, useSelector } from 'react-redux';
import axios from '../../utilities/axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deleteTransient, transientKey } from '../../utilities/cache';
import { setLoading } from '../../features/providers/generic';
import Form from '../Form';
import {
  clearFormSubmitInvalidSlug,
  setFormSubmitInvalidSlug,
} from '../../features/providers/orgInformationSlice';
import {
  getFirstMissingRequiredSlug,
  scrollToOrgField,
} from '../../utilities/orgFormValidation';

const Org = () => {
  const Fields = useSelector((state) => state.orgInformation.data.fields);

  const fieldsExist = Object.keys(Fields).length > 0;
  const postId = useSelector((state) => state.orgInformation.data.post_id);
  const inputContext = useSelector((state) => state.generic.inputContext);

  const dispatch = useDispatch();

  const submit = async (e) => {
    e.preventDefault();
    const firstMissing = getFirstMissingRequiredSlug(Fields, inputContext);
    if (firstMissing) {
      dispatch(setFormSubmitInvalidSlug(firstMissing));
      scrollToOrgField(firstMissing);
      return;
    }
    dispatch(clearFormSubmitInvalidSlug());
    try {
      dispatch(setLoading(true));

      const request = await axios.put('/organization', {
        fields: Fields,
        postId,
      });

      toast('Successfully updated');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      toast('Error!' + e.message);
    } finally {
      deleteTransient(transientKey);
      dispatch(setLoading(false));
    }
  };

  const formElementsWrapStyle = {
    zIndex: 1,

    transition: 'opacity 0.3s ease-in-out',
    position: 'relative',
  };

  return (
    <>
      <form noValidate onSubmit={submit}>
        <div style={formElementsWrapStyle}>
          <Form fields={Fields} fieldsExist={fieldsExist} />
        </div>
      </form>
    </>
  );
};

export default Org;
